<!--用户之声-->
<template>
    <div>
        <el-row class="box">
            <el-form :size="size1">
                <el-col :span="2"><el-form-item label="工单提醒" prop="id"></el-form-item></el-col>
                <el-col :span="10">
                    <el-badge v-for="(item) in countList" :value="item.count" :key="item.status" class="item">
                        <el-button  :size="size1" @click="init(item.status)">{{stateCn(item.status)}}</el-button>
                    </el-badge>
                </el-col>
            </el-form>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
            <el-form :size="size1" :model="queryInfo" ref="queryRef" label-width="70px">
                <el-col :span="4">
                    <el-form-item label="工单编号" prop="id">
                        <el-input :size="size1" v-model="queryInfo.id" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8.5">
                    <el-form-item label="时间">
                        <el-date-picker
                                v-model="dateRange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="关键字" prop="keyCode">
                        <el-input :size="size1" v-model="queryInfo.keyCode" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-button :size="size1" v-permission="['BUSINESS-WORKORDER-PAGE']" type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
                    <el-button :size="size1" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
                    <el-button :size="size1" v-permission="['SYS-REPLYCONFIG-UPDATEW']" type="primary" icon="el-icon-edit" @click="autoReply()">差评自动回复</el-button>
                </el-col>
            </el-form>
        </el-row>
        <el-row style="">
            <el-table v-loading="loading" ref="tableRef" border stripe checkBox :height="treeTableHeight" :data="tablelist" >
                <template v-for="(v,k) in columns">
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.label==='操作'">
                        <template slot-scope="scope">
                            <el-button v-permission="['BUSINESS-WORKORDER-DETAILM']" type="primary" icon="el-icon-edit" size="mini" round @click="showDialog(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='status'">
                        <template slot-scope="scope">
                            <span>{{stateCn(scope.row.status)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
                </template>
            </el-table>
            <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        </el-row>
        <el-dialog title=""
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :destroy-on-close="true"
                   width="50%"
                   @close="dialogVisible = false">
            <el-card shadow="hover" class="detail" >
                <div slot="header" class="clearfix">
                    <span>工单详情</span>
                </div>
                <el-descriptions class="margin-top" title="" :column="1" :size="size">
                    <el-descriptions-item label="工单标题">{{form.title}}</el-descriptions-item>
                </el-descriptions>
                <el-row>
                    <el-col :span="21">
                        <el-descriptions class="margin-top" title="" :column="3" :size="size">
                            <el-descriptions-item label="工单编号">{{form.id}}</el-descriptions-item>
                            <el-descriptions-item label="提交时间">{{form.createTime}}</el-descriptions-item>
                            <el-descriptions-item label="工单状态">{{stateCn(form.status)}}</el-descriptions-item>
                        </el-descriptions>
                    </el-col>
                    <el-col :span="3">
                        <el-button v-permission="['BUSINESS-WORKORDER-ACCEPT']" type="primary" size="mini" @click="acceptHandle" v-if="form.status==='created'">受理</el-button>
                        <!--<span v-else-if="form.status==='wait_confirmed'||form.status==='confirmed'||form.status==='appraised'"></span>-->
                        <el-button v-if="form.status==='accepted'||form.status==='answered'||form.status==='feedbacked'" v-permission="['BUSINESS-WORKORDER-SETCONFIRM']" type="primary" size="mini" @click="setconfirmHandle" >设置为待确认</el-button>
                    </el-col>
                </el-row>
            </el-card>
            <el-card shadow="hover" class="detail" style="margin-top: 15px;">
                <div slot="header" class="clearfix">
                    <span>沟通记录</span>
                </div>
                <div v-for="(item,i) in detailsList" :key="i">
                    <el-row v-if="item.manager" class="manager">
                        <el-col :span="12" :offset="11" class="cont">
                            <el-row><span>{{item.content.title}}</span><span>{{item.createTime}}</span><span>{{item.operatorNickName}}</span></el-row>
                            <el-row v-if="item.content.content!=undefined"><!---->
                                <div class="cont1">
                                    {{item.content.content}}
                                </div>
                            </el-row>
                            <el-row v-if="item.content.eva_content!=undefined">
                                <div class="cont1">
                                    {{item.content.eva_content}}
                                    <div>
                                        <el-radio-group v-model="item.content.eva_solve" fill="#FFDA4B">
                                            <el-radio :label="1">已解决</el-radio>
                                            <el-radio :label="0">未解决</el-radio>
                                        </el-radio-group>
                                    </div>
                                    <div>
                                        <el-radio-group v-model="item.content.eva_level" fill="#FFDA4B">
                                            <el-radio :label="0">好评</el-radio>
                                            <el-radio :label="1">中评</el-radio>
                                            <el-radio :label="2">差评</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                            </el-row>
                        </el-col>
                        <el-col :span="1" >
                            <img v-if="item.operatorHeaderPath!=undefined&&item.operatorHeaderPath!=''" :src="COMMON.httpUrl + '/static' + item.operatorHeaderPath+ '?token=Bearer '+ token">
                            <img v-else src="../../../assets/header/kefu1.png">
                        </el-col>
                    </el-row>
                    <el-row v-else class="kehu" >
                        <el-col :span="1" >
                            <img v-if="item.operatorHeaderPath!=undefined&&item.operatorHeaderPath!=''" :src="COMMON.httpUrl + '/static' + item.operatorHeaderPath+ '?token=Bearer '+ token">
                            <img v-else src="../../../assets/header/yonghu1.png">
                        </el-col>
                        <el-col :span="12" class="cont">
                            <el-row><span>{{item.operatorNickName}}</span><span>{{item.createTime}}</span><span>{{item.content.title}}</span></el-row>
                            <el-row v-if="item.content.content!=undefined">
                                <div class="cont1">
                                    {{item.content.content}}
                                </div>
                            </el-row>
                            <el-row v-if="item.content.eva_content!=undefined">
                                <div class="cont1">
                                    {{item.content.eva_content}}
                                    <div>
                                        <el-radio-group v-model="item.content.eva_solve" fill="#FFDA4B">
                                            <el-radio :label="1">已解决</el-radio>
                                            <el-radio :label="0">未解决</el-radio>
                                        </el-radio-group>
                                    </div>
                                    <div>
                                        <el-radio-group v-model="item.content.eva_level" fill="#FFDA4B">
                                            <el-radio :label="0">好评</el-radio>
                                            <el-radio :label="1">中评</el-radio>
                                            <el-radio :label="2">差评</el-radio>
                                        </el-radio-group>
                                    </div>

                                </div>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
            <el-card shadow="hover" class="detail" v-if="form.status==='accepted'||form.status==='answered'||form.status==='feedbacked'" style="margin-top: 15px;">
                <div slot="header" class="clearfix">
                    <span>我要回复</span>
                </div>
                <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.content">
                </el-input>
                <el-button v-permission="['BUSINESS-WORKORDER-ANSWER']" type="primary" size="mini" @click="answerHandle" style="margin-top: 10px;">提交</el-button>
            </el-card>
        </el-dialog>
        <div v-if="replyDialogVisible">
            <el-dialog title="自动回复设置"
                       :visible.sync="replyDialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :destroy-on-close="true"
                       width="30%"
                       @close="replyDialogVisible = false">
                <ReplyConfig :type="replyType" @closeEvent="replyDialogVisible = false"></ReplyConfig>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {dictDataList} from '@/api/dict'
import {timeFormat1} from '@/utils/common'
import {workorderPage,workorderCount,workorderAccept,workorderAnswer,workorderSetconfirm,workorderDetails,getWorkorderById} from '@/api/workorder'
import Pagination from '@/components/pagination/index'
import { mapGetters } from 'vuex'
import ReplyConfig from '@/components/replyconfig/Index'
export default {
    name: 'BUSINESS-WORKORDER',
    components: {
        Pagination, ReplyConfig
    },
    data(){
        return {
            tablelist: [],
            columns: [
                {
                    label: '工单编号',
                    prop: 'id',
                    fixed: 'left',
                    width: '180px'
                },{
                    label: '标题',
                    prop: 'title',
                    // width: '180px'
                },{
                    label: '提交用户',
                    prop: 'userName',
                    width: '180px'
                },{
                    label: '提交时间',
                    prop: 'createTime',
                    width: '160px'
                },{
                    label: '状态',
                    prop: 'status',
                    width: '80px'
                },{
                    label: '用户id',
                    prop: 'uidUser',
                    width: '180px'
                },{
                    label: '操作',
                    type: 'template',
                    template: 'action',
                    width: '100px',
                    fixed: 'right'
                }
            ],
            treeTableHeight: 650,
            total: 0,
            queryInfo: {
                pagesize: 10,
                pagenum: 1,
                id: null,
                keyCode: null,
                createTimeEnd: null,
                createTimeStart: null,
                status: null
            },
            dateRange: [],
            stateList: [],
            stateObject:{},
            countList:[],
            dialogVisible: false,
            form:{
                title:'',
                content:''
            },
            size: '',
            detailsList:[],
            replyDialogVisible:false,
            replyType:'work_order',
            size1:this.COMMON.size,
            loading: true
        }
    },
    methods: {
        getHeight() {
            this.treeTableHeight = window.innerHeight - 60 -40 -55 -70 -62 -32 + 'px'
        },
        init(status) {
            // console.log('status',status)
            if(status!=undefined){
                this.queryInfo.status=status
            }
            if(this.dateRange!=null && this.dateRange.length>0){
                this.queryInfo.createTimeStart = this.dateRange[0]
                this.queryInfo.createTimeEnd = this.dateRange[1]
            }
            if(this.queryInfo.id!=undefined) {
                this.queryInfo.id = this.queryInfo.id.trim()
            }
            if(this.queryInfo.keyCode!=undefined) {
                this.queryInfo.keyCode = this.queryInfo.keyCode.trim()
            }
            let param = {}
            param.current = this.queryInfo.pagenum
            param.size = this.queryInfo.pagesize
            this.loading = true
            workorderPage(param,this.queryInfo).then(response => {
                if(response.code!=200)  return this.$message.error('获取工单数据失败！')
                this.tablelist = response.data.records
                this.total = response.data.total
                this.loading = false
                // console.log('工单数据',response)
            })
        },
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize
            this.init('')
        },
        /**
         * 分页组件切换页事件处理
         * @param newPage
         */
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage
            this.init('')
        },
        stateCn(value){
            return this.stateObject[value]
        },
        getStates(cb){
            /*let param = {}
            param.current = 1
            param.size = 100*/
            let data={type: 'sys_workorder_status'}
            dictDataList(data).then(response => {
                if (response.code != 200){
                    return this.$message.error('获取维修单状态失败！')
                }else{
                    this.stateList = response.data //.records
                    for (let i=0;i<this.stateList.length;i++){
                        this.stateObject[this.stateList[i].value]=this.stateList[i].label
                    }
                    // console.log('状态=',this.stateObject)
                    cb(this)
                }
            })
        },
        timeDay(timetick){
            return timeFormat1(timetick)
        },
        showDialog(item){
            // console.log('详情',item)
            this.form = item
            this.details()
            this.dialogVisible=true
        },
        resetQuery() {
            this.$refs.queryRef.resetFields()
            this.init('')
        },
        getCount(){
            workorderCount().then(response => {
                if (response.code != 200)
                    return this.$message.error('获取各状态工单数失败！')
                this.countList = response.data
            })
        },
        acceptHandle(){
            workorderAccept(this.form.id).then(response => {
                if (response.code != 200)
                    return this.$message.error(response.msg)
                this.init('')
                this.getWorkorder()
                this.details()
                this.$message.success(response.msg)
            })
        },
        answerHandle(){
            workorderAnswer({id:this.form.id,content:this.form.content}).then(response => {
                if (response.code != 200)
                    return this.$message.error(response.msg)
                this.init('')
                this.getWorkorder()
                this.details()
                this.$message.success(response.msg)
            })
        },
        setconfirmHandle(){
            workorderSetconfirm(this.form.id).then(response => {
                if (response.code != 200)
                    return this.$message.error(response.msg)
                this.init('')
                this.getWorkorder()
                this.details()
                this.$message.success(response.msg)
            })
        },
        details(){
            workorderDetails(this.form.id).then(response => {
                if (response.code != 200)
                    return this.$message.error(response.msg)
                this.detailsList=response.data
                // this.$message.success(response.msg)
            })
        },
        getWorkorder(){
            getWorkorderById(this.form.id).then(response => {
                if (response.code != 200)
                    return this.$message.error(response.msg)
                this.form=response.data
            })
        },
        autoReply(){
            this.replyDialogVisible=true
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryInfo.pagenum = 1
            this.init()
        }
    },
    created() {
        this.getHeight()
        window.addEventListener('resize', this.getHeight)
        this.getStates(function (e) {
            e.init('')
        })
        this.getCount()
    },
    computed: {
        ...mapGetters([
            'token'
        ])
    },
    activated(){
        this.$refs.tableRef.doLayout()
    }
}
</script>

<style lang="scss" scoped>
    .item {
        /*margin-top: 10px;*/
        margin-right: 40px;
    }
    /*.box >>> .el-form-item {
        margin-bottom: 0px;
    }*/
    .el-divider--horizontal {
        margin: 0px 0px 20px;
    }
    .detail >>> .el-card__header {
        padding: 10px 20px!important;
    }
    .manager,.kehu{
        margin-bottom: 16px;
        img{
            max-width: 30px;
            max-height: 30px;
        }
        .cont{
            span{
                color:#999;
            }
        }
    }
    .manager{
        .cont{
            text-align: right;
            padding-right: 10px;
            .cont1{
                margin-top: 4px;
                padding: 16px 20px;
                border-radius: 8px 0 8px 8px;
                box-shadow: 0 1px 4px 0 rgb(0 136 17);
                -webkit-box-shadow:0 1px 4px 0 rgb(135 197 229);
                background-color: #e5f3ff;
            }
            /**/
            span:nth-child(2),span:nth-child(3){
                margin-left: 10px;
                font-size: 12px;
            }
        }
    }
    .kehu{
        .cont{
            padding-left: 10px;
            .cont1{
                margin-top: 4px;
                padding: 16px 20px;
                border-radius: 0 8px 8px 8px;
                -webkit-box-shadow: 0 1px 4px 0 rgb(0 0 123);
                box-shadow: 0 1px 4px 0 rgb(153 153 153);
                background-color: #fff;
            }
            span:nth-child(1),span:nth-child(2){
                margin-right: 10px;
                font-size: 12px;
            }
        }
    }

</style>
